

import { CheckCircle, FileText } from "lucide-react";

const Trust = () => {
  const features = [
    "Intelligent PDF detection and filtering",
    "Seamless Yahoo! search integration", 
    "Automatic new tab functionality"
  ];

  return (
    <div className="bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 py-24">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full mb-6 shadow-xl">
            <FileText className="w-10 h-10 text-white" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent mb-6">
            Smart PDF Search
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Designed to make finding PDF documents faster and more efficient than ever
          </p>
        </div>
        
        <div className="max-w-3xl mx-auto">
          <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-10 shadow-2xl border border-white/20">
            <div className="space-y-6">
              {features.map((feature, index) => (
                <div key={index} className="flex items-center gap-6 p-4 rounded-2xl hover:bg-blue-50/50 transition-colors duration-300 group">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                      <CheckCircle className="w-6 h-6 text-white" />
                    </div>
                  </div>
                  <span className="text-lg font-semibold text-gray-800 group-hover:text-blue-700 transition-colors duration-300">
                    {feature}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Trust;
